import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { PinnedServices } from './components/PinnedServices';
import { ActivityFeed } from './components/ActivityFeed';
import { ProjectForm } from './components/ProjectForm';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-[#24292f]" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />

        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-8" data-id="element-4">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8" data-id="element-5">
            {/* Left Sidebar (Profile-like info could go here, but we'll use it for Activity Feed on desktop) */}
            <div className="lg:col-span-3 lg:order-1 hidden lg:block space-y-6" data-id="element-6">
              <div className="flex items-center gap-3 mb-4" data-id="element-7">
                <img src="https://api.dicebear.com/7.x/identicon/svg?seed=code-vanta" alt="Code Vanta Logo" className="w-8 h-8 rounded-full border border-[#d0d7de]" data-id="element-8" />
                <span className="font-bold text-sm" data-id="element-9">code-vanta</span>
              </div>
              <ActivityFeed data-id="element-10" />
            </div>

            {/* Main Content Area */}
            <div className="lg:col-span-9 lg:order-2 space-y-8" data-id="element-11">
              {/* Mobile Activity Feed (visible only on mobile) */}
              <div className="lg:hidden" data-id="element-12">
                <ActivityFeed data-id="element-13" />
              </div>

              <PinnedServices data-id="element-14" />

              <div className="border-t border-[#d0d7de] my-8" data-id="element-15"></div>

              <ProjectForm data-id="element-16" />
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-17" />
    </div>;
}